export default "__VITE_ASSET__54c1506f__"